import { ApplicationRef, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';

import { ConfigModule } from 'Angular/config/config.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { ImageModule } from 'Angular/features/directives/image/image.module';

import { SupportContactInfoPageComponent } from './components/contact-page/support-contact-info-page.component';
import { SupportCategoryPageComponent } from './components/support-category-page/support-category-page.component';
import { SupportSidebarComponent } from './components/support-sidebar/support-sidebar.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';

import { getLogger } from 'Angular/state/logger';

@NgModule({
    declarations: [SupportContactInfoPageComponent, SupportCategoryPageComponent, SupportSidebarComponent],
    imports: [
        BrowserModule,
        ConfigModule,
        IconModule,
        ImageModule,
        NavigationModule,
        ModalBaseModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
    ],
})
export class AppModule {
    ngDoBootstrap(appRef: ApplicationRef): void {
        appRef.bootstrap(SupportCategoryPageComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
    }
}
